import { useEffect, useState } from 'react';
import { procApi } from '../../api/procurement.js';
import { useAuth } from '../../contexts/AuthContext.jsx';

export default function Products() {
  const { can } = useAuth();
  const canCreate = can('product', 'create');
  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [filters, setFilters] = useState({ search: '', category: '' });
  const [showForm, setShowForm] = useState(false);

  function refresh() { procApi.products(filters).then((d) => setItems(d?.items || [])); }
  useEffect(refresh, [filters]);
  useEffect(() => { procApi.productCategories().then((d) => setCategories(d?.items || [])); }, []);

  async function submit(e) {
    e.preventDefault();
    const fd = new FormData(e.currentTarget);
    await procApi.createProduct({
      sku: fd.get('sku'),
      name: fd.get('name'),
      categoryId: fd.get('categoryId') || null,
      unit: fd.get('unit') || 'EA',
      reorderPoint: Number(fd.get('reorderPoint') || 0),
      reorderQty: Number(fd.get('reorderQty') || 0),
      standardCost: Number(fd.get('standardCost') || 0),
      listPrice: Number(fd.get('listPrice') || 0),
      trackBatches: fd.get('trackBatches') === 'on',
    });
    e.currentTarget.reset();
    setShowForm(false);
    refresh();
  }

  return (
    <section>
      <header className="page-header">
        <h1>Products</h1>
        {canCreate && <button className="btn primary" onClick={() => setShowForm((s) => !s)}>{showForm ? 'Close' : '+ New Product'}</button>}
      </header>
      {showForm && (
        <form onSubmit={submit} className="card form-card grid-form">
          <label>SKU<input name="sku" required /></label>
          <label>Name<input name="name" required /></label>
          <label>Category
            <select name="categoryId">
              <option value="">—</option>
              {categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </label>
          <label>Unit<input name="unit" defaultValue="EA" /></label>
          <label>Reorder point<input name="reorderPoint" type="number" step="0.01" defaultValue={0} /></label>
          <label>Reorder qty<input name="reorderQty" type="number" step="0.01" defaultValue={0} /></label>
          <label>Standard cost<input name="standardCost" type="number" step="0.0001" defaultValue={0} /></label>
          <label>List price<input name="listPrice" type="number" step="0.0001" defaultValue={0} /></label>
          <label className="checkbox-row full"><input type="checkbox" name="trackBatches" /> Track batches / expiry</label>
          <div className="full actions"><button className="btn primary" type="submit">Create</button></div>
        </form>
      )}

      <div className="card form-card grid-form">
        <label>Search<input value={filters.search} onChange={(e) => setFilters({ ...filters, search: e.target.value })} /></label>
        <label>Category
          <select value={filters.category} onChange={(e) => setFilters({ ...filters, category: e.target.value })}>
            <option value="">All</option>
            {categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </label>
      </div>

      <div className="card">
        <table className="data-table">
          <thead><tr><th>SKU</th><th>Name</th><th>Category</th><th>Unit</th><th>Reorder Pt</th><th>Cost</th><th>Price</th></tr></thead>
          <tbody>
            {items.map((p) => (
              <tr key={p.id}>
                <td><code>{p.sku}</code></td>
                <td>{p.name}{p.track_batches && <span className="chip">batched</span>}</td>
                <td className="muted">{p.category_name || '—'}</td>
                <td>{p.unit}</td>
                <td>{Number(p.reorder_point).toFixed(2)}</td>
                <td>{Number(p.standard_cost).toFixed(4)}</td>
                <td>{Number(p.list_price).toFixed(4)}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={7} className="muted">No products yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
